import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "reactstrap";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import LoadingContainer from "../components/LoadingContainer";
import SVGIcon from "../components/SVGIcon";
import ActiveOrganisation from "../components/ActiveOrganisation";
import FileDownloadButton from "../components/FileDownloadButton";

import {
  fetchCategories,
  fetchOrganisationList,
  deleteOrganisaitonFromApp,
  downloadPlistFile,
  downloadManifestFile
} from "../store/actions/footfall-actions";

import { searchStringInObjectArray, sortLabelAlphabetically } from "../utilities/helpers";


const OrganisationList = props => {
  const organisationListDataShowing = useSelector(state => { // whole data
    return {
      physicalOrganisationArray:
        state.footfallConfiguration.physicalOrganisationArray,
      digitalOrganisationArray:
        state.footfallConfiguration.digitalOrganisationArray
    };
  });

  const organisationListDataLoaded = useSelector( //prop
    state => state.footfallConfiguration.organisationListDataLoaded
  );

  const categoriesData = useSelector(
    state => state.footfallConfiguration.categoriesData
  );

  const currentAppData = props.clientListData.find(
    element => element.clientId === props.clientId
  );

  const userAccountName = useSelector(state => state.auth.tokenPayload.user);

  let currentAppOsType;
  if (currentAppData !== null && currentAppData !== undefined) {
    currentAppOsType = searchStringInObjectArray(
      props.appIdNow,
      currentAppData.value,
      "_id"
    ).value.os;
  }
  console.log(currentAppOsType)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCategories());

    if (props.appIdNow !== undefined && props.appIdNow !== null) {
      dispatch(fetchOrganisationList(props.appIdNow));
      setIndex(0);
      setCurrentSubcategory({
        label: "All Subcategory",
        name: "All Subcategory"
      });
      setTabValue(0); // Default to Digital (0)
    }
  }, [props.appIdNow, dispatch]);

  const headCells = [
    { id: "expand", label: "", sortable: false },
    { id: "name", label: "Oraganisation Name", sortable: true },
    { id: "country", label: "Country", sortable: true },
    { id: "subcategory", label: "Subcategory", sortable: true },
    { id: "type", label: "Type", sortable: true },
    { id: "mobileApps", label: "Total Mobile Apps", sortable: true },
    { id: "monitoring", label: "Monitoring Apps", sortable: true },
    { id: "checkbox", label: "", sortable: false }
  ];
  const cellWidth = idx => {
    switch (idx) {
      case 0:
        return { width: "3%", textAlign: "center" };
      case 1:
        return { width: "28%", textAlign: "Left", paddingLeft: "1rem" };
      case 7:
        return { width: "5%" };
      default:
        return { width: "12%" };
    }
  };

  const rowsPerPage = 10;

  const rows = organisationListDataShowing.physicalOrganisationArray.concat(
    organisationListDataShowing.digitalOrganisationArray
  );

  const getUniqueSubcategoryOptions = (organizationType) => {
    // Filter rows by organization type: tabValue 0 = Digital, 1 = Physical
    let filteredRows = rows;
    if (organizationType === 0) {
      // Digital organizations
      filteredRows = rows.filter(ele => ele.organisationType === "digital");
    } else if (organizationType === 1) {
      // Physical organizations
      filteredRows = rows.filter(ele => ele.organisationType !== "digital");
    }

    let subcategoryOptions =
      filteredRows !== undefined && filteredRows.length > 0
        ? filteredRows.map(item => {
            return {
              label: `${item.subcategory}`,
              name: item.subcategory
            };
          })
        : [];

    subcategoryOptions = Array.from(
      new Set(subcategoryOptions.map(s => s.label))
    ).map(label => {
      return {
        label: label,
        name: subcategoryOptions.find(s => s.label === label).name
      };
    });

    subcategoryOptions = sortLabelAlphabetically(subcategoryOptions, "label");

    subcategoryOptions.unshift({
      label: "All Subcategory",
      name: "All Subcategory"
    });

    return  subcategoryOptions;
  };

  const [currentIndex, setIndex] = useState(0);
  const [currentSubcategory, setCurrentSubcategory] = useState({
    label: "All Subcategory",
    name: "All Subcategory"
  });
  const [checkedItems, setCheckedItems] = useState({});
  const [isOpen, toggleModal] = useState(false);

  const [category, setCategory] = useState({
    label: "All category",
    value: 0
  });

  const [tabValue, setTabValue] = useState(0); // 0 = Digital, 1 = Physical

  // Compute filter options based on current table data and selected tab
  const uniqueSubcategoryOptions = useMemo(() => {
    return getUniqueSubcategoryOptions(tabValue);
  }, [tabValue, rows]);

  // Filter headCells based on tab - hide mobileApps and monitoring columns for Physical tab
  const filteredHeadCells = useMemo(() => {
    if (tabValue === 1) {
      // Physical Organization tab - exclude mobileApps and monitoring columns
      return headCells.filter(cell => cell.id !== "mobileApps" && cell.id !== "monitoring");
    }
    // Digital Organization tab - show all columns
    return headCells;
  }, [tabValue]);

  const [sortColumn, setSortColumn] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [expandedRows, setExpandedRows] = useState(new Set());

  const filteredRow = rows => {
    // filter the rows by the subcategory and organisation type (tab)
    return rows
    .filter(ele =>
      currentSubcategory.label !== "All Subcategory"
        ? ele.subcategory === currentSubcategory.label
        : true
    )
    .filter(ele => {
      // Filter by tab: 0 = Digital, 1 = Physical
      if (tabValue === 0) {
        return ele.organisationType === "digital";
      } else if (tabValue === 1) {
        return ele.organisationType !== "digital";
      }
      return true;
    });
  };

  // Calculate total organizations for the current tab
  const totalOrganizations = useMemo(() => {
    // Get filtered organizations based on current tab and subcategory filter
    const filteredRows = filteredRow(rows);
    return filteredRows.length;
  }, [tabValue, rows, currentSubcategory]);

  // Calculate total monitoring apps for digital organizations
  const totalMonitoringApps = useMemo(() => {
    if (tabValue !== 0) {
      // Only calculate for Digital Organization tab
      return 0;
    }

    // Get filtered digital organizations
    const digitalRows = filteredRow(rows);

    // Calculate total monitoring apps across all digital organizations
    let total = 0;
    digitalRows.forEach(org => {
      if (org.mobileApps && Array.isArray(org.mobileApps)) {
        total += org.mobileApps.filter(app => app.monitoring === true).length;
      }
    });

    return total;
  }, [tabValue, rows, currentSubcategory]);

  const handleSelectChange = event => {
    setCurrentSubcategory(event);
    setIndex(0);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setIndex(0);
    // Reset subcategory filter when switching tabs
    setCurrentSubcategory({
      label: "All Subcategory",
      name: "All Subcategory"
    });
  };

  const handleSort = column => {
    if (sortColumn === column) {
      // Toggle direction if clicking the same column
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // Set new column and default to ascending
      setSortColumn(column);
      setSortDirection("asc");
    }
    setIndex(0); // Reset pagination when sorting changes
  };

  const sortRows = rows => {
    return [...rows].sort((a, b) => {
      let aValue, bValue;

      switch (sortColumn) {
        case "name":
          aValue = a.name ? a.name.toLowerCase() : "";
          bValue = b.name ? b.name.toLowerCase() : "";
          break;
        case "country":
          aValue = a.country ? a.country.toLowerCase() : "";
          bValue = b.country ? b.country.toLowerCase() : "";
          break;
        case "subcategory":
          aValue = a.subcategory ? a.subcategory.toLowerCase() : "";
          bValue = b.subcategory ? b.subcategory.toLowerCase() : "";
          break;
        case "type":
          aValue = a.organisationType === "digital" ? "digital" : "physical";
          bValue = b.organisationType === "digital" ? "digital" : "physical";
          break;
        case "mobileApps":
          aValue = a.mobileApps && Array.isArray(a.mobileApps) ? a.mobileApps.length : 0;
          bValue = b.mobileApps && Array.isArray(b.mobileApps) ? b.mobileApps.length : 0;
          break;
        case "monitoring":
          aValue = a.mobileApps && Array.isArray(a.mobileApps)
            ? a.mobileApps.filter(app => app.monitoring === true).length
            : 0;
          bValue = b.mobileApps && Array.isArray(b.mobileApps)
            ? b.mobileApps.filter(app => app.monitoring === true).length
            : 0;
          break;
        default:
          return 0;
      }

      if (aValue < bValue) {
        return sortDirection === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  const handleToggleModal = () => toggleModal(!isOpen);

  const toggleRowExpansion = (rowId) => {
    setExpandedRows(prev => {
      const newSet = new Set(prev);
      if (newSet.has(rowId)) {
        newSet.delete(rowId);
      } else {
        newSet.add(rowId);
      }
      return newSet;
    });
  };

  const handleLeftButtonClick = () => {
    setIndex(prevIndex => Math.max(prevIndex - rowsPerPage, 0));
  };

  const handleRightButtonClick = () => {
    console.log(currentIndex)
    console.log(filteredRow(rows).length);
    console.log(Math.floor(filteredRow(rows).length / rowsPerPage) * rowsPerPage)
    if (currentIndex + rowsPerPage < filteredRow(rows).length) {
      setIndex(prevIndex =>
        Math.min(
          prevIndex + rowsPerPage,
          Math.floor(filteredRow(rows).length / rowsPerPage) * rowsPerPage
        )
      );
    }
  };

  const handleCheck = e =>
    setCheckedItems({ ...checkedItems, [e.target.name]: e.target.checked });

  const removeOrganisations = async () => {
    let deleteDataArray = [];
    Object.keys(checkedItems).length > 0 &&
      Object.keys(checkedItems).map((item, idx) => {
        checkedItems[item] !== false && deleteDataArray.push(item);
      });

    await dispatch(
      deleteOrganisaitonFromApp({
        appIds: [props.appIdNow],
        organIds: deleteDataArray,
        userName: userAccountName
      })
    );

    reGettingtheData();
    handleClose();
  };

  const handleFileDownload = () => {
    let mobileAppIdArray = [];

    // Only download files for digital organizations (tabValue === 0)
    const digitalOrganizations = rows.filter(ele => ele.organisationType === "digital");

    for (let i = 0; i < digitalOrganizations.length; i++) {
      if (
        digitalOrganizations[i].mobileAppIds !== undefined &&
        Array.isArray(digitalOrganizations[i].mobileAppIds) === true
      ) {
        mobileAppIdArray = mobileAppIdArray.concat(digitalOrganizations[i].mobileAppIds);
      }
    }

    if(currentAppOsType ==='iOS'){
      dispatch(
        downloadPlistFile({
          appId: props.appIdNow,
          mobileAppIds: mobileAppIdArray
        })
      );
    }else{
      dispatch(
        downloadManifestFile({
          appId: props.appIdNow,
          mobileAppIds: mobileAppIdArray
        })
      );
    }


  };


  const reGettingtheData = () => {
    setTimeout(() => {
      dispatch(fetchOrganisationList(props.appIdNow));
    }, 1000);
  };

  //popover
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleRemoveButton = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Get the selected client name
  const selectedClient = props.clientListData.find(
    client => client.clientId === props.clientId
  );
  const clientName = selectedClient ? selectedClient.label : null;

  // Get the selected app name
  let appName = null;
  if (currentAppData && props.appIdNow) {
    const selectedApp = searchStringInObjectArray(
      props.appIdNow,
      currentAppData.value,
      "_id"
    );
    appName = selectedApp ? selectedApp.value.name : null;
  }

  return (
    <main className="FootfallInsights_main" style={{ marginTop: "2rem" }}>
      {(clientName || appName) && (
        <div style={{ padding: "1rem 2rem", marginBottom: "1rem" }}>
          {clientName && (
            <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 600, color: "#333" }}>
              {clientName}
            </h2>
          )}
          {appName && (
            <h3 style={{ margin: "0.5rem 0 0 0", fontSize: "1.25rem", fontWeight: 500, color: "#666" }}>
              {appName}
            </h3>
          )}
        </div>
      )}
      <div className="Organisations container">
        <LoadingContainer loading={false}>
          <div className="Organisations" style={{ padding: 0 }}>
            <div className="Organisations_inner" style={{ display: "block" }}>
              <div style={{ marginBottom: "1rem", display: "block" }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  aria-label="organisation type tabs"
                >
                  <Tab label="Digital Organization" />
                  <Tab label="Physical Organization" />
                </Tabs>
              </div>

              <TabPanel value={tabValue} index={0}>
                <div style={{ padding: "0.75rem 0", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "1.5rem" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <span style={{ fontSize: "0.875rem", color: "#666", fontWeight: 500 }}>
                      Total Organizations:
                    </span>
                    <span style={{ fontSize: "1rem", color: "#2196F3", fontWeight: 600 }}>
                      {totalOrganizations}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <span style={{ fontSize: "0.875rem", color: "#666", fontWeight: 500 }}>
                      Total Monitoring Apps:
                    </span>
                    <span style={{ fontSize: "1rem", color: "#2196F3", fontWeight: 600 }}>
                      {totalMonitoringApps}
                    </span>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem", width: "100%" }}>
                  <Select
                    inputId="criteria-modal-select-subcategory"
                    className="CriteriaModal_search-organisation-input"
                    style={{ minWidth: "200px" }}
                    classNamePrefix="CriteriaModal_search-organisation-input_"
                    placeholder="Filter by Subcategory"
                    isDisabled={props.appIdNow === null || uniqueSubcategoryOptions.length <= 1}
                    isRtl={false}
                    isSearchable
                    name="subcategory"
                    options={uniqueSubcategoryOptions}
                    value={currentSubcategory}
                    onChange={event => handleSelectChange(event)}
                  />

                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ display: "inline-block" }}
                    onClick={() => toggleModal(true)}
                    disabled={props.appIdNow === null}
                  >
                    Active Organisation
                  </Button>

                  <FileDownloadButton
                    handleFileDownload={handleFileDownload}
                    appIdNow={props.appIdNow}
                    currentAppOsType={currentAppOsType}
                  />
                </div>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                <div style={{ padding: "0.75rem 0", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <span style={{ fontSize: "0.875rem", color: "#666", fontWeight: 500 }}>
                    Total Organizations:
                  </span>
                  <span style={{ fontSize: "1rem", color: "#2196F3", fontWeight: 600 }}>
                    {totalOrganizations}
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem", width: "100%" }}>
                  <Select
                    inputId="criteria-modal-select-subcategory-physical"
                    className="CriteriaModal_search-organisation-input"
                    style={{ minWidth: "200px" }}
                    classNamePrefix="CriteriaModal_search-organisation-input_"
                    placeholder="Filter by Subcategory"
                    isDisabled={props.appIdNow === null || uniqueSubcategoryOptions.length <= 1}
                    isRtl={false}
                    isSearchable
                    name="subcategory"
                    options={uniqueSubcategoryOptions}
                    value={currentSubcategory}
                    onChange={event => handleSelectChange(event)}
                  />

                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ display: "inline-block" }}
                    onClick={() => toggleModal(true)}
                    disabled={props.appIdNow === null}
                  >
                    Active Organisation
                  </Button>
                </div>
              </TabPanel>

              <div className="Organisations_tableArea">
                <div>
                  {organisationListDataLoaded ? (
                    <table>
                      <tr className="Organisations_tableRowHead">
                        {filteredHeadCells.map((headCell, idx) => (
                          <td
                            key={headCell.id}
                            className={
                              idx === 0
                                ? "Organisations_tableRowHead_firstCell"
                                : "Organisations_tableRowHead_nthCell"
                            }
                            style={{
                              ...cellWidth(idx),
                              cursor: headCell.sortable ? "pointer" : "default",
                              userSelect: "none"
                            }}
                            onClick={() => headCell.sortable && handleSort(headCell.id)}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                              <span>{headCell.label}</span>
                              {headCell.sortable && sortColumn === headCell.id && (
                                <span style={{ fontSize: "0.75rem" }}>
                                  {sortDirection === "asc" ? "▲" : "▼"}
                                </span>
                              )}
                            </div>
                          </td>
                        ))}
                      </tr>
                      <tbody>
                        {sortRows(
                          rows
                            .filter(ele => {
                              // Filter by tab: 0 = Digital, 1 = Physical
                              if (tabValue === 0) {
                                return ele.organisationType === "digital";
                              } else if (tabValue === 1) {
                                return ele.organisationType !== "digital";
                              }
                              return true;
                            })
                            .filter(ele =>
                              currentSubcategory.label !== "All Subcategory"
                                ? ele.subcategory === currentSubcategory.label
                                : true
                            )
                        )
                          .slice(currentIndex, currentIndex + rowsPerPage)
                          .map((row, index) => {
                            const isExpanded = expandedRows.has(row._id);
                            const isDigital = row.organisationType === "digital";
                            const hasMobileApps = row.mobileApps && Array.isArray(row.mobileApps) && row.mobileApps.length > 0;
                            const totalMobileApps = row.mobileApps && Array.isArray(row.mobileApps) ? row.mobileApps.length : 0;
                            const monitoringCount = row.mobileApps && Array.isArray(row.mobileApps)
                              ? row.mobileApps.filter(app => app.monitoring === true).length
                              : 0;

                            return (
                              <React.Fragment key={row._id}>
                                <tr
                                  className={"Organisations_tableRowBody"}
                                >
                                  {filteredHeadCells.map((headCell, idx) => (
                                    <td
                                      key={headCell.id}
                                      className={
                                        idx === 0
                                          ? "Organisations_tableRowBody_firstCell"
                                          : idx === 1
                                          ? "Organisations_tableRowBody_firstCell"
                                          : "Organisations_tableRowBody_nthCell"
                                      }
                                      style={cellWidth(idx)}
                                    >
                                      {headCell.id === "expand" ? (
                                        isDigital ? (
                                          <button
                                            onClick={() => toggleRowExpansion(row._id)}
                                            style={{
                                              background: "none",
                                              border: "none",
                                              cursor: "pointer",
                                              padding: "0.25rem",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center"
                                            }}
                                            title={isExpanded ? "Collapse" : "Expand"}
                                          >
                                            <span style={{ fontSize: "0.75rem" }}>
                                              {isExpanded ? "▼" : "▶"}
                                            </span>
                                          </button>
                                        ) : (
                                          <span style={{ width: "1rem", display: "inline-block" }}></span>
                                        )
                                      ) : headCell.id === "name" ? (
                                        row.name
                                      ) : headCell.id === "country" ? (
                                        row.country
                                      ) : headCell.id === "subcategory" ? (
                                        row.subcategory
                                      ) : headCell.id === "admin" ? (
                                        <span
                                          className={`Organisations_badge_${row.admin}`}
                                        >
                                          {row.admin}{" "}
                                        </span>
                                      ) : headCell.id === "type" ? (
                                        row.organisationType === "digital" ? (
                                          "Digital"
                                        ) : (
                                          "Physical"
                                        )
                                      ) : headCell.id === "mobileApps" ? (
                                        <span>{totalMobileApps}</span>
                                      ) : headCell.id === "monitoring" ? (
                                        <span>{monitoringCount}</span>
                                      ) : headCell.id === "checkbox" ? (
                                        <input
                                          checked={checkedItems[row._id]}
                                          name={row._id}
                                          type="checkbox"
                                          onChange={handleCheck}
                                        />
                                      ) : null}
                                    </td>
                                  ))}
                                </tr>
                                {isDigital && isExpanded && (
                                  <tr>
                                    <td colSpan={filteredHeadCells.length} style={{ padding: "1rem", backgroundColor: "#f5f5f5" }}>
                                      <div style={{ paddingLeft: "2rem" }}>
                                        <h4 style={{ marginBottom: "0.5rem", fontSize: "1rem", fontWeight: "bold" }}>
                                          Mobile Apps
                                        </h4>
                                        {row.mobileApps && Array.isArray(row.mobileApps) && row.mobileApps.length > 0 ? (
                                          <div style={{ marginTop: "0.5rem" }}>
                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                              <thead>
                                                <tr style={{ borderBottom: "1px solid #ddd" }}>
                                                  <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "bold" }}>ID</th>
                                                  <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "bold" }}>Name</th>
                                                  <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "bold" }}>iOS Scheme</th>
                                                  <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "bold" }}>Android Package</th>
                                                  <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "bold" }}>Monitoring</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {row.mobileApps.map((app) => (
                                                  <tr key={app._id} style={{ borderBottom: "1px solid #eee" }}>
                                                    <td style={{ padding: "0.5rem" }}>{app._id || "-"}</td>
                                                    <td style={{ padding: "0.5rem" }}>{app.name || "-"}</td>
                                                    <td style={{ padding: "0.5rem" }}>{app.primaryIOSScheme || "-"}</td>
                                                    <td style={{ padding: "0.5rem" }}>{app.androidPackageName || "-"}</td>
                                                    <td style={{ padding: "0.5rem" }}>
                                                      <span
                                                        style={{
                                                          padding: "0.25rem 0.5rem",
                                                          borderRadius: "4px",
                                                          fontSize: "0.875rem",
                                                          fontWeight: "500",
                                                          backgroundColor: app.monitoring ? "#d4edda" : "#f8d7da",
                                                          color: app.monitoring ? "#155724" : "#721c24"
                                                        }}
                                                      >
                                                        {app.monitoring ? "Yes" : "No"}
                                                      </span>
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <p style={{ margin: 0, color: "#999", fontStyle: "italic" }}>
                                            No mobile apps associated with this organisation.
                                          </p>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                    </table>
                  ) : (
                    <div>
                      <LinearProgress />
                    </div>
                  )}
                </div>

                <div style={{ padding: 10, textAlign: "right" }}>
                  <div style={{ marginRight: "1rem", display: "inline-block" }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleRemoveButton}
                      disabled={props.appIdNow === null}
                    >
                      Remove Organisation
                    </Button>
                  </div>
                  <span className="WhereYourCustomersHaveBeenGraph_top-row_showing">
                    Showing {currentIndex + 1} -{" "}
                    {Math.min(
                      currentIndex + rowsPerPage,
                      filteredRow(rows).length
                    )}{" "}
                    of {filteredRow(rows).length}
                  </span>
                  <div className="WhereYourCustomersHaveBeenGraph_top-row_button-group">
                    <button type="button" onClick={handleLeftButtonClick}>
                      <SVGIcon icon="left-arrow" />
                    </button>
                    <button type="button" onClick={handleRightButtonClick}>
                      <SVGIcon icon="right-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LoadingContainer>

        <Modal
          isOpen={isOpen}
          toggle={handleToggleModal}
          style={{ width: "62rem" }}
          centered
          contentClassName="CriteriaModal_wrapper"
          backdropClassName="CriteriaModal_background"
        >
          <ActiveOrganisation
            categoriesData={categoriesData}
            ActiveOrganisationData={
              tabValue === 0
                ? organisationListDataShowing.digitalOrganisationArray
                : organisationListDataShowing.physicalOrganisationArray
            }
            appIdNow={props.appIdNow}
            clientAppsNow={props.clientAppsNow}
            clientId={props.clientId}
            fetchOrganisationList={fetchOrganisationList}
            toggleModal={toggleModal}
            currentAppOsType={currentAppOsType}
            clientListData={props.clientListData}
            clientIndexNow={props.clientListData.map(item => item.clientId).indexOf(props.clientId)}
            organisationTypeTab={tabValue}
          />
        </Modal>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          <div style={{ padding: "1rem" }}>
            <h2 style={{ fontSize: "1.25rem" }}>
              {" "}
              Are you sure you wanna REMOVE these organisations?
            </h2>
            <p style={{ fontSize: "1rem" }}>
              It will only remove from this app
            </p>
            <Button variant="text" color="primary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="text"
              color="primary"
              onClick={() => removeOrganisations()}
            >
              Confirm
            </Button>
          </div>
        </Popover>
      </div>
    </main>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`organisation-tabpanel-${index}`}
      aria-labelledby={`organisation-tab-${index}`}
      style={{ display: value === index ? 'block' : 'none' }}
      {...other}
    >
      {value === index && <div style={{ display: 'block' }}>{children}</div>}
    </div>
  );
}

export default OrganisationList;
